import _ from 'lodash';

// constants
import { TABLE_URI_ADDON } from '../../../constants/constant';
import { getRequest } from '../../Common/network-call';
import { fetchAppuserCategory } from '../../../actions';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_BOOKMARKS_BY_TYPE = 'FETCH_BOOKMARKS_BY_TYPE';
export const FETCH_BOOKMARKS_DATA = 'FETCH_BOOKMARKS_DATA';

export const fetchBookmarksByType = (session, type = 'speaker', callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=${type})`
  );
  let related = '';
  let orderby = 'createdon%20DESC';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    dispatch({
      type: FETCH_BOOKMARKS_BY_TYPE,
      payload: {}
    });
    dispatch({
      type: FETCH_BOOKMARKS_DATA,
      payload: {}
    });
    getRequest(
      url,
      session,
      dispatch,
      response => {
        let inStr = '( ';
        _.map(response.resource, (item, index) => {
          if (index == response.resource.length - 1) {
            inStr += item.typeid + ' )';
          } else {
            inStr += item.typeid + ', ';
          }
        });
        dispatch(fetchBookmarksData(session, type, inStr));
        if (type == 'user') {
          dispatch(fetchAppuserCategory(session));
        }

        dispatch({
          type: FETCH_BOOKMARKS_BY_TYPE,
          payload: { data: response.resource, count: response.meta.count }
        });
        callback({ success: 1, data: response.resource });
      },
      error => {}
    );
  };
};

export const fetchBookmarksData = (session, type, ids) => {
  let filter = null;
  let related = null;
  let orderby = null;
  let url = null;

  if (type == 'schedule') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(sessionid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(sessionid IN ${ids})`);

    related = `colordetails,speaker_by_sessionspeakers,speaker_by_speakerid&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}`;
    orderby = FETCH_ORDERS.session;
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }
  //
  else if (type == 'speaker') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(speakerid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(speakerid IN ${ids})`);
    related = 'session_by_sessionspeakers';
    orderby = 'createdon%20DESC';
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }
  //
  else if (type == 'sponsor') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(sponsorid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(sponsorid IN ${ids})`);
    related = '';
    orderby = 'createdon%20DESC';
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }
  //
  else if (type == 'exhibitor') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(exhibitorid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(exhibitorid IN ${ids})`);
    related = 'appuser_by_exhibitoridfk';
    orderby = 'createdon%20DESC';
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }
  //
  else if (type == 'news') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(newsid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(newsid IN ${ids})`);
    related = '';
    orderby = 'createdon%20DESC';
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.news}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }
  //
  else if (type == 'user') {
    filter =
      ids === '( '
        ? encodeURI(`(eventid=${session.eventid})AND(appuserid=0)`)
        : encodeURI(`(eventid=${session.eventid})AND(appuserid IN ${ids})`);
    related = '';
    orderby = 'username';
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?include_count=true&related=${related}&filter=(${filter})&order=${orderby}`;
  }

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_BOOKMARKS_DATA,
          payload: { data: response.resource, count: response.meta.count }
        });
      },
      error => {}
    );
  };
};

export const clearBookmarksData = () => {
  return dispatch => {
    dispatch({ type: FETCH_BOOKMARKS_DATA, payload: {} });
  };
};
